import { Box } from '@mui/material';

import CalculatorInstancePricing from './CalculatorInstancePricing';
import CalculatorTechSpecs from './CalculatorTechSpecs';
import withStyles from './mui/withStylesAdapter';

const withJss = withStyles(() => ({
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 2rem',
  },
}));

function DetailsPanel({
  calculatorInputs,
  internalParamValues,
  calculatorResult,
  setMode,
  error,
}) {
  return (
    <Box>
      <Box className="grid-panel pricing-box">
        <CalculatorInstancePricing
          internalParams={internalParamValues}
          calculatedCluster={calculatorResult}
          calculatorInputs={calculatorInputs}
          setMode={setMode}
          error={error}
        />
      </Box>
      {!error && (
        <Box className="grid-panel tech-specs">
          <CalculatorTechSpecs
            calculatedCluster={calculatorResult}
            internalParams={internalParamValues}
          />
        </Box>
      )}
    </Box>
  );
}

export default withJss(DetailsPanel);
